import { render } from "./AlienPlayerScoutReportView.vue?vue&type=template&id=7cf98ba2"
import script from "./AlienPlayerScoutReportView.vue?vue&type=script&lang=js"
export * from "./AlienPlayerScoutReportView.vue?vue&type=script&lang=js"

import "./AlienPlayerScoutReportView.vue?vue&type=style&index=0&id=7cf98ba2&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__